export const getMinutesPerHour = (value) => {
  if (!value) {
    return;
  }

  const [hoursString, minutesString] = value?.split(':');
  const hours = Number(hoursString);
  const minutes = Number(minutesString);
  const pluralizedHours = hours > 1 ? 'hours' : 'hour';
  const hoursText = hours ? `${hours} ${pluralizedHours} and ` : '';

  return `${hoursText}${minutes} minutes per hour`;
};
